import { RouteComponentProps, withRouter } from 'react-router';
import * as React from 'react';

interface ScrollToTopProps extends RouteComponentProps<any> {
}

class ScrollToTop extends React.Component<ScrollToTopProps> {
    
    componentDidUpdate(prevProps: any){
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
          }
    }

    render() {
        return this.props.children;
    }

}

export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/ScrollToTop.tsx